import React from "react";
import { useTranslation } from "react-i18next";
import IconContainer from "@/components/ui/icon-container";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { AlertTriangle } from "@dreamhub/designsystem/icons";
import { ProposalStatusBadge } from "./ProposalStatusBadge";
import { isTracked } from "./tracking";
import { Proposal } from "./types";

interface Props {
  proposal: Pick<
    Proposal,
    "status" | "actions" | "signedCount" | "signerCount"
  >;
  trackingPaused: boolean;
}

// A proposal's status; one still out says so when its tracking is paused,
// since the status shown is only the last one known.
export const TrackedProposalStatus: React.FC<Props> = ({
  proposal,
  trackingPaused
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1">
      <ProposalStatusBadge proposal={proposal} />
      {trackingPaused && isTracked(proposal) ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <span tabIndex={0} data-test="proposal-tracking-paused">
              <IconContainer size="5" color="warning" as="span">
                <AlertTriangle />
              </IconContainer>
            </span>
          </TooltipTrigger>
          <TooltipContent enableMarkdown={false}>
            {t("contracts.proposals.trackingPaused")}
          </TooltipContent>
        </Tooltip>
      ) : null}
    </div>
  );
};
